import React, {useEffect, useState} from "react";
import "./components/list-property.css";
import hero from "./components/images/hero.jpg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faMap, faMoneyBill1 } from "@fortawesome/free-regular-svg-icons";
import { faCircleCheck, faImage } from "@fortawesome/free-regular-svg-icons";
import { useForm } from "react-hook-form";
import { useLanguage } from "../../../i18n/LanguageContext";
import PropertyMapPicker from "../../common/PropertyMapPicker";

function ListProperty(){
    const { t, lang } = useLanguage();
    const isNe = lang === "ne";
    const {register, handleSubmit, setValue, watch, trigger, formState:{errors},} = useForm();
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [municipalities, setMunicipalities] = useState([]);

    const [selectedState, setSelectedState] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [propertyLat, setPropertyLat] = useState(null);
    const [propertyLng, setPropertyLng] = useState(null);
    const [mapPinError, setMapPinError] = useState("");

    const onSubmit = async (data)=>{
        try{
            if (propertyLat == null || propertyLng == null || isNaN(Number(propertyLat)) || isNaN(Number(propertyLng))) {
                setMapPinError(isNe ? "कृपया नक्शामा सटिक स्थान पिन गर्नुहोस्।" : "Please pin your exact property location on the map.");
                setCurrentStep(1);
                return;
            }

            const formData = new FormData();
            const token = localStorage.getItem("token");

            formData.append("propertyName", data.propertyName);
            formData.append("propertyType", data.propertyType);
            formData.append("propertyAddress", data.propertyAddress);
            formData.append("propertyState", data.propertyState);
            formData.append("propertyDistrict", data.propertyDistrict);
            formData.append("propertyMunicipality", data.propertyMunicipality);
            formData.append("bedrooms", data.bedrooms &&!isNaN(data.bedrooms)?data.bedrooms:0);
            formData.append("bathrooms", data.bathrooms &&!isNaN(data.bathrooms)?data.bathrooms:0);
            formData.append("squarefeet", data.squarefeet &&!isNaN(data.squarefeet)?data.squarefeet:0);
            formData.append("amenities", JSON.stringify(data.amenities || []));
            formData.append("propertyPrice", data.propertyPrice);
            formData.append("propertyDescription", data.propertyDescription);
            if (propertyLat != null) formData.append("propertyLat", propertyLat);
            if (propertyLng != null) formData.append("propertyLng", propertyLng);

            if(data.photos && data.photos.length>0){
                for(let i=0; i<data.photos.length; i++){
                    formData.append("photos", data.photos[i]);
                }
            }
            const response = await fetch("/api/listproperty", {
                method: "POST",
                headers:{
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });
            const result = await response.json();

            if(response.ok){
                alert(isNe ? "सम्पत्ति सफलतापूर्वक सूचीबद्ध भयो!" : "Property listed successfully!");
                console.log(result);
            }
            else{
                console.error("Error listing property:", result);
                if (result?.code === "PROPERTY_PIN_REQUIRED") {
                    setMapPinError(isNe ? "कृपया नक्शामा सटिक स्थान पिन गर्नुहोस्।" : "Please pin your exact property location on the map.");
                    setCurrentStep(1);
                    return;
                }
                alert(result?.message || (isNe ? "सम्पत्ति सूचीबद्ध गर्न सकिएन।" : "Failed to list property."));
            }
        } catch(error){
            console.error("Error submitting form:", error);
            alert(isNe ? "केही समस्या भयो।" : "Something went wrong.");
        }
    }

    useEffect(()=>{
        const fetchStates = async()=>{
            try{
                const response = await fetch("/api/states");
                const data = await response.json();
                setStates(data);
            }
            catch(error){
                console.error("Error fetching states:", error);
            }
        };
        fetchStates();
    }, []);

    useEffect(()=>{
        if(selectedState){
            const fetchDistricts = async()=>{
                try{
                    const response = await fetch(`/api/districts/${selectedState}`);
                    const data = await response.json();
                    setDistricts(data);
                    setMunicipalities([]);
                }
                catch(error){
                    console.error("Error fetching districts:", error);
                }
            };
            fetchDistricts();
        }
    }, [selectedState]);

    useEffect(()=>{
        if(selectedDistrict){
            const fetchMunicipalities = async()=>{
                try{
                    const response = await fetch(`/api/municipalities/${selectedDistrict}`);
                    const data = await response.json();
                    setMunicipalities(data);
                }
                catch(error){
                    console.error("Error fetching municipalities:", error);
                }
            };
            fetchMunicipalities();
        }
    }, [selectedDistrict]);

    useEffect(() => {
        register("photos", {
            validate: (files) => {
                if (!files || files.length === 0) {
                    return isNe ? "कृपया कम्तीमा ५ वटा फोटो अपलोड गर्नुहोस्।" : "Please upload at least 5 photos.";
                }
                if (files.length < 5) {
                    return isNe ? "कम्तीमा ५ वटा तस्बिर अपलोड गर्नु आवश्यक छ।" : "You must upload at least 5 images.";
                }
                for (let file of files) {
                    if (file.size > 5 * 1024 * 1024) {
                        return isNe
                            ? `फाइल "${file.name}" 5MB सीमा भन्दा ठूलो छ।`
                            : `File "${file.name}" exceeds 5MB size limit.`;
                    }
                }
                return true;
            },
        });
    }, [register, isNe]);


    const [imagePreviews, setImagePreviews] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);

    const stepTitles = [
        isNe ? "आधारभूत जानकारी" : "Basic Info",
        isNe ? "स्थान" : "Location",
        isNe ? "विवरण र सुविधाहरू" : "Details & Amenities",
        isNe ? "मूल्य र फोटो" : "Pricing & Photos",
    ];

    const stepDescriptions = [
        isNe ? "सम्पत्तिको मुख्य जानकारीबाट सुरु गरौं" : "Start with the core details of your property",
        isNe ? "ठेगाना र नक्शामा स्थान सुनिश्चित गर्नुहोस्" : "Confirm address and map position",
        isNe ? "कोठा, क्षेत्रफल र सुविधाहरू थप्नुहोस्" : "Add rooms, size, and amenities",
        isNe ? "मूल्य राख्नुहोस् र राम्रो फोटो अपलोड गर्नुहोस्" : "Set pricing and upload strong photos",
    ];

    const stepValidationFields = [
        ["propertyName", "propertyType"],
        ["propertyAddress", "propertyState", "propertyDistrict", "propertyMunicipality"],
        [],
        ["propertyPrice", "propertyDescription", "photos"],
    ];

    const totalSteps = stepTitles.length;
    const progressPercent = Math.round(((currentStep + 1) / totalSteps) * 100);

    const handleNextStep = async () => {
        const fields = stepValidationFields[currentStep] || [];
        if (fields.length > 0) {
            const isValid = await trigger(fields, { shouldFocus: true });
            if (!isValid) return;
        }

        if (currentStep === 1) {
            const hasPin = propertyLat != null && propertyLng != null && !isNaN(Number(propertyLat)) && !isNaN(Number(propertyLng));
            if (!hasPin) {
                setMapPinError(isNe ? "कृपया नक्शामा सटिक स्थान पिन गर्नुहोस्।" : "Please pin your exact property location on the map.");
                return;
            }
        }

        setCurrentStep((prev) => Math.min(prev + 1, totalSteps - 1));
    };

    const handlePreviousStep = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 0));
    };

    const goToStep = (stepIndex) => {
        if (stepIndex <= currentStep) {
            setCurrentStep(stepIndex);
        }
    };

    return(
        <div className="property-listing">
            <div className="hero">
                <img src={hero} alt="List property hero"/>
                <div className="hero-title">
                    <h1>{isNe ? "आफ्नो सम्पत्ति सूचीबद्ध गर्नुहोस्" : "List Your Property"}</h1>
                    <p>{isNe ? "आफ्नो सुन्दर स्थान संसारभरिका भाडावालसँग साझा गर्नुहोस्" : "Share your beautiful space with renters from around the world"}</p>
                </div>
            </div>
            <div className="container d-flex flex-column p-2 listing-shell">
                <div className="form-title listing-heading">
                    <h2 className="p-2">{isNe ? "सम्पत्ति विवरण" : "Property Details"}</h2>
                    <p>{isNe ? "तपाईंको सम्पत्ति हाम्रो प्लेटफर्ममा सूचीबद्ध गर्न तलको जानकारी भर्नुहोस्।" : "Fill out the information below to get your property listed on our platform."}</p>
                    <p>{isNe ? "यसलाई केही मिनेट मात्र लाग्छ!" : "It only takes a few minutes!"}</p>
                </div>
                <div className="listing-flow-header">
                    <div className="flow-progress-meta d-flex justify-content-between align-items-center">
                        <span>{isNe ? `चरण ${currentStep + 1} / ${totalSteps}` : `Step ${currentStep + 1} of ${totalSteps}`}</span>
                        <span>{progressPercent}% {isNe ? "पूरा" : "complete"}</span>
                    </div>
                    <div className="flow-progress-track" aria-hidden="true">
                        <div className="flow-progress-fill" style={{ width: `${progressPercent}%` }} />
                    </div>
                    <div className="flow-stepper">
                        {stepTitles.map((title, idx) => {
                            const stateClass = idx === currentStep ? "is-active" : idx < currentStep ? "is-done" : "is-upcoming";
                            return (
                                <button
                                    key={title}
                                    type="button"
                                    className={`step-pill ${stateClass}`}
                                    onClick={() => goToStep(idx)}
                                    disabled={idx > currentStep}
                                >
                                    <span className="step-count">{idx + 1}</span>
                                    <span className="step-copy">{title}</span>
                                </button>
                            );
                        })}
                    </div>
                    <p className="flow-step-description mb-0">{stepDescriptions[currentStep]}</p>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="listing-form">
                    <div className="form-container d-flex flex-column p-4">
                        <div className={`flow-step-panel ${currentStep === 0 ? "active" : "hidden"}`}>
                        <div className="card d-flex flex-column p-4 m-3 listing-card">
                            <div className="topic d-flex gap-2">
                                <FontAwesomeIcon icon={faHouse} size="xl" className="text-success my-1"/>
                                <span className="card-title">{isNe ? "आधारभूत जानकारी" : "Basic Information"}</span>
                            </div>
                            <p className="card-description text-secondary">{isNe ? "तपाईंको सम्पत्तिबारे जानकारी दिनुहोस्" : "Tell us about your property"}</p>
                            <div>
                                <label htmlFor="propertyName" className="mt-4 mx-1 info-label">{isNe ? "सम्पत्तिको नाम" : "Property Name"}
                                    <span className="text-danger">*</span>
                                </label>
                                <input 
                                    type="text"  
                                    className="form-control mt-1" 
                                    placeholder={isNe ? "उदाहरण: चाबहिलको सुन्दर घर" : "Beautiful House in Chabahil"}
                                    {...register("propertyName", { required: true })}
                                />
                                <span className="text-danger fs-6 fw-normal mx-1">
                                    {errors.propertyName?.type==="required" && (isNe ? "सम्पत्तिको नाम आवश्यक छ" : "Property name is required")}
                                </span>
                            </div>
                            <div>
                                <label htmlFor="propertyType" className="mt-4 mx-1 info-label">{isNe ? "सम्पत्ति प्रकार" : "Property Type"}
                                    <span className="text-danger">*</span>
                                </label>
                                <select {...register("propertyType", { required: true })} className="form-select mt-1">
                                    <option value="">{isNe ? "--कृपया छान्नुहोस्--" : "--Please Select--"}</option>
                                    <option value="house">{t('findProperty.categories.house')}</option>
                                    <option value="apartment">{t('findProperty.categories.apartment')}</option>
                                    <option value="land">{t('findProperty.categories.land')}</option>
                                    <option value="commercial">{t('findProperty.categories.commercial')}</option>
                                    <option value="villa">{t('findProperty.categories.villa')}</option>
                                    <option value="condo">{t('findProperty.categories.condo')}</option>
                                    <option value="cabin">{t('findProperty.categories.cabin')}</option>
                                    <option value="room">{t('findProperty.categories.room')}</option>
                                </select>
                                <span className="text-danger fs-6 fw-normal mx-1">
                                    {errors.propertyType?.type==="required" && (isNe ? "सम्पत्ति प्रकार आवश्यक छ" : "Property type is required")}
                                </span>
                            </div>
                        </div>
                        </div>

                        <div className={`flow-step-panel ${currentStep === 1 ? "active" : "hidden"}`}>
                        <div className="card d-flex flex-column p-4 m-3 listing-card">
                            <div className="topic d-flex gap-2">
                                <FontAwesomeIcon icon={faMap} size="xl" className="text-warning my-1"/>
                                <span className="card-title">{isNe ? "स्थान" : "Location"}</span>
                            </div>
                            <p className="card-description text-secondary">{isNe ? "तपाईंको सम्पत्ति कहाँ अवस्थित छ?" : "Where is your property located?"}</p>
                            <div>
                                <label htmlFor="propertyAddress" className="mt-4 mx-1 info-label">{isNe ? "ठेगाना" : "Street Address"}
                                    <span className="text-danger">*</span>
                                </label>
                                <input id="propertyAddressInput" type="text"  {...register("propertyAddress", { required: true })} className="form-control mt-1" placeholder={isNe ? "उदाहरण: १२३ हिमालयन डाँडा" : "123 Himalayan Dr"}/>
                                <span className="text-danger fs-6 fw-normal mx-1">
                                    {errors.propertyAddress?.type==="required" && (isNe ? "ठेगाना आवश्यक छ" : "Street address is required")}
                                </span>
                            </div>

                            <div className="mt-4">
                                <label className="mx-1 info-label mb-2 d-block">
                                    {isNe ? "नक्शामा सटिक स्थान चयन गर्नुहोस्" : "Pin Exact Location on Map"}
                                    <span className="text-danger ms-1">*</span>
                                </label>
                                <PropertyMapPicker
                                    lat={propertyLat}
                                    lng={propertyLng}
                                    isNe={isNe}
                                    propertyType={watch("propertyType")}
                                    onChange={({ lat, lng, address }) => {
                                        setMapPinError("");
                                        setPropertyLat(lat);
                                        setPropertyLng(lng);
                                        // Auto-fill address field if it is empty
                                        if (address && !document.getElementById('propertyAddressInput')?.value) {
                                            setValue("propertyAddress", address);
                                        }
                                    }}
                                />
                                {mapPinError && <span className="text-danger fs-6 fw-normal mx-1 d-block mt-2">{mapPinError}</span>}
                            </div>
                            <div className="d-flex gap-4 form-grid-3">
                                <div className="d-flex flex-column flex-fill">
                                    <label htmlFor="propertyState" className="mt-4 mx-1 info-label">{isNe ? "प्रदेश/राज्य" : "State/Province"}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <select  {
                                        ...register("propertyState", {
                                            required: true,
                                            onChange: (e) => setSelectedState(e.target.value)
                                        })} 
                                        className="form-select mt-1"
                                    >
                                        <option value="">{isNe ? "--कृपया छान्नुहोस्--" : "--Please Select--"}</option>
                                        {states.map((state)=>(
                                            <option key={state.id} value={state.id}>{state.state_name}</option>
                                        ))}
                                    </select>
                                    <span className="text-danger fs-6 fw-normal mx-1">
                                        {errors.propertyState?.type==="required" && (isNe ? "प्रदेश आवश्यक छ" : "State is required")}
                                    </span>
                                </div>
                                <div className="d-flex flex-column flex-fill">
                                    <label htmlFor="propertyDistrict" className="mt-4 mx-1 info-label">{isNe ? "जिल्ला" : "District"}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <select {
                                        ...register("propertyDistrict", {
                                            required: true,
                                            onChange: (e)=>setSelectedDistrict(e.target.value),
                                            disabled: !selectedState || districts.length===0 
                                        })} 
                                        className="form-select mt-1"
                                    >
                                        <option value="">{isNe ? "--कृपया छान्नुहोस्--" : "--Please Select--"}</option>
                                        {districts.map((district)=>(
                                            <option key={district.id} value={district.id}>
                                                {district.district_name}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="text-danger fs-6 fw-normal mx-1">
                                        {errors.propertyDistrict?.type==="required" && (isNe ? "जिल्ला आवश्यक छ" : "District is required")}
                                    </span>
                                </div>
                                <div className="d-flex flex-column flex-fill">
                                    <label htmlFor="propertyMunicipality" className="mt-4 mx-1 info-label">{isNe ? "नगरपालिका" : "Municipality"}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <select {...register("propertyMunicipality", { required: true })} 
                                        className="form-select mt-1"
                                        disabled={!selectedDistrict || municipalities.length===0}>
                                        <option value="">{isNe ? "--कृपया छान्नुहोस्--" : "--Please Select--"}</option>
                                        {municipalities.map((municipality)=>(
                                            <option key={municipality.id} value={municipality.id}>
                                                {municipality.municipality_name}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="text-danger fs-6 fw-normal mx-1">
                                        {errors.propertyMunicipality?.type==="required" && (isNe ? "नगरपालिका आवश्यक छ" : "Municipality is required")}
                                    </span>
                                </div>
                            </div>
                        </div>
                        </div>

                        <div className={`flow-step-panel ${currentStep === 2 ? "active" : "hidden"}`}>
                        <div className="card d-flex flex-column p-4 m-3 listing-card">
                            <div className="topic d-flex gap-2">
                                <FontAwesomeIcon icon={faHouse} size="xl" className="text-primary my-1"/>
                                <span className="card-title">{isNe ? "सम्पत्ति विवरण" : "Property Details"}</span>
                            </div>
                            <p className="card-description text-secondary">{isNe ? "आकार र सुविधाहरू वर्णन गर्नुहोस्" : "Describe the size and features"}</p>
                            <div className="d-flex gap-4 form-grid-3">
                                <div className="d-flex flex-column flex-fill">
                                    <label htmlFor="bedrooms" className="mt-4 mx-1 info-label">{isNe ? "सुत्ने कोठा" : "Bedrooms"}</label>
                                    <input type="number" className="form-control" placeholder="3" {...register("bedrooms", {valueAsNumber: true})}/>
                                </div>
                                <div className="d-flex flex-column flex-fill">
                                    <label htmlFor="bathrooms"  className="mt-4 mx-1 info-label">{isNe ? "बाथरुम" : "Bathrooms"}</label>
                                    <input type="number" {...register("bathrooms",{valueAsNumber:true})}className="form-control" placeholder="2.5"/>
                                </div>
                                <div className="d-flex flex-column flex-fill">
                                    <label htmlFor="squarefeet" className="mt-4 mx-1 info-label">{isNe ? "वर्ग फिट" : "Square Feet"}</label>
                                    <input type="number" {...register("squarefeet", {valueAsNumber:true})}className="form-control" placeholder="1500"/>
                                </div>
                            </div>
                        </div>

                        <div className="card d-flex flex-column p-4 m-3 listing-card">
                            <div className="topic d-flex gap-2">
                                <FontAwesomeIcon icon={faCircleCheck} size="xl" className="text-danger my-1"/>
                                <span className="card-title">{t('amenities.sectionTitle')}</span>
                            </div>
                            <p className="card-description text-secondary">{t('amenities.sectionDesc')}</p>
                            <div>
                                <div className="row row-cols-4 amenities-grid">
                                    {[
                                        { id: "wifi", value: "WiFi" },
                                        { id: "kitchen", value: "Kitchen" },
                                        { id: "water", value: "Water" },
                                        { id: "freeparking", value: "Free Parking" },
                                        { id: "airconditioning", value: "Air Conditioning" },
                                        { id: "heating", value: "Heating" },
                                        { id: "electricity", value: "Electricity" },
                                        { id: "petfriendly", value: "Pet Friendly" },
                                        { id: "gym", value: "Gym" },
                                        { id: "hotwater", value: "Hot Water" },
                                        { id: "playground", value: "Playground" },
                                        { id: "disablefriendly", value: "Disable Friendly" },
                                    ].map(({ id, value })=>{
                                        return(
                                            <label className="col mb-3 d-flex amenity-item" key={id} htmlFor={id}>
                                                <input
                                                    type="checkbox"
                                                    value={value}
                                                    {...register("amenities")}
                                                    id={id}
                                                    className="form-check-input amenity-checkbox bd-primary"
                                                />
                                                <span className="form-check-label amenity-label">
                                                    {t(`amenities.${id}`)}
                                                </span>
                                            </label>
                                        )
                                    })}  
                                </div>
                            </div>
                        </div>
                        </div>

                        <div className={`flow-step-panel ${currentStep === 3 ? "active" : "hidden"}`}>
                        <div className="card d-flex flex-column p-4 m-3 listing-card">
                            <div className="topic d-flex gap-2">
                                <FontAwesomeIcon icon={faMoneyBill1} size="xl" className="text-success my-1"/>
                                <span className="card-title">{isNe ? "मूल्य र विवरण" : "Pricing & Description"}</span>
                            </div>
                            <p className="card-description text-secondary">{isNe ? "मूल्य राख्नुहोस् र सम्पत्ति वर्णन गर्नुहोस्" : "Set your price and describe your property"}</p>
                            <div>
                                <label htmlFor="propertyPrice" className="mt-4 mx-1 info-label">{isNe ? "मासिक भाडा (रु)" : "Price per Month (NPR)"}
                                    <span className="text-danger">*</span>
                                </label>
                                <input type="number" {...register("propertyPrice", {required:true})} className="form-control mt-1" placeholder="15000"/>
                                <span className="text-danger fs-6 fw-normal mx-1">
                                    {errors.propertyPrice?.type==="required" && (isNe ? "सम्पत्तिको मूल्य आवश्यक छ" : "Property price is required")}
                                </span>
                            </div>
                            <div>
                                <label htmlFor="propertyDescription" className="mt-4 mx-1 info-label">{isNe ? "सम्पत्ति विवरण" : "Property Description"}
                                    <span className="text-danger">*</span>
                                </label>
                                <textarea className="form-control" {...register("propertyDescription", {required:true})} placeholder={isNe ? "तपाईंको सम्पत्ति किन विशेष छ, वर्णन गर्नुहोस्..." : "Describe what makes your property special..."}/>
                                <span className="text-danger fs-6 fw-normal mx-1">
                                    {errors.propertyDescription?.type==="required" && (isNe ? "विवरण आवश्यक छ" : "Description is required")}
                                </span>
                            </div>
                        </div>

                         <div className="card d-flex flex-column p-4 m-3 listing-card">
                            <div className="topic d-flex gap-2">
                                <FontAwesomeIcon icon={faImage} size="xl" className="text-warning my-1"/>
                                <span className="card-title">{isNe ? "तस्बिरहरू" : "Photos"}</span>
                            </div>
                            <p className="card-description text-secondary">{isNe ? "तपाईंको सम्पत्तिका तस्बिर अपलोड गर्नुहोस्" : "Upload photos of your property"}</p>
                            {imagePreviews.length>0 &&(
                                <div className="d-flex flex-wrap gap-2 mb-3">
                                    {imagePreviews.map((src, index)=>(
                                        <img
                                            key={index}
                                            src={src}
                                            alt={`preview-${index}`}
                                            className="img-thumbnail"
                                            style={{width:"100px", height:"100px", objectFit:"cover"}}
                                        />
                                    ))}
                                </div>
                            )}
                            <div>
                                <label htmlFor="propertyImages" className="mt-2 mx-1 info-label">
                                    {isNe ? "सम्पत्ति तस्बिरहरू" : "Property Images"}
                                    <span className="text-danger">*</span>
                                </label>
                                <input 
                                    id="propertyImages"
                                    type="file"
                                    className="form-control mt-1"
                                    accept="image/*"
                                    multiple
                                    
                                    onChange={(e)=>{
                                        const files = e.target.files;
                                        if(!files||files.length===0){
                                            setImagePreviews([]);
                                            setValue("photos", files);
                                            trigger("photos");
                                            return;
                                        }
                                        const imageUrls = Array.from(files).map((file)=>
                                            URL.createObjectURL(file)
                                        );
                                        setImagePreviews(imageUrls);
                                        setValue("photos", files);
                                        trigger("photos"); 
                                    }}
                                />                                  
                                <span className="text-danger fs-6 fw-normal mx-1">
                                    {errors.photos?.message}
                                </span>  
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between submit-row flow-actions">
                        <button
                            type="button"
                            className="btn btn-outline-secondary flow-back-btn"
                            onClick={handlePreviousStep}
                            disabled={currentStep === 0}
                        >
                            {isNe ? "पछाडि" : "Back"}
                        </button>
                        {currentStep < totalSteps - 1 ? (
                            <button
                                type="button"
                                className="btn btn-primary flow-next-btn"
                                onClick={handleNextStep}
                            >
                                {isNe ? "अर्को चरण" : "Next Step"}
                            </button>
                        ) : (
                            <button type="submit" className="btn btn-primary listing-submit-btn">{isNe ? "सम्पत्ति सूचीबद्ध गर्नुहोस्" : "List Property"}</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default ListProperty;